import { createEnv } from '@t3-oss/env-nextjs'
import { z } from 'zod'

export const env = createEnv({
  client: {
    NEXT_PUBLIC_BASE_URL: z.string(),
    NEXT_PUBLIC_APP_ENV: z.enum(['local', 'dev', 'prod']),
    NEXT_PUBLIC_HETZNER_S3_ENV: z.enum(['dev', 'prod']),
    NEXT_PUBLIC_HETZNER_S3_BUCKET_URL: z.url(),
  },
  runtimeEnv: {
    NEXT_PUBLIC_BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
    NEXT_PUBLIC_APP_ENV: process.env.NEXT_PUBLIC_APP_ENV,
    NEXT_PUBLIC_HETZNER_S3_ENV: process.env.NEXT_PUBLIC_HETZNER_S3_ENV,
    NEXT_PUBLIC_HETZNER_S3_BUCKET_URL: process.env.NEXT_PUBLIC_HETZNER_S3_BUCKET_URL,
  },
})
